<template>
  <el-dialog v-model="open" title="绑定微信" width="400" align-center destroy-on-close @open="onOpen" @closed="onClosed">
    <div class="wechat-bind-hint">
      <el-text type="info" size="small">请使用微信扫描二维码，绑定后可通过「其他登录方式」扫码登录</el-text>
    </div>
    <WechatOpenLoginPanel v-if="bindState" hint-text="请使用微信扫描二维码完成绑定" :redirect-uri="bindRedirectUri" :oauth-state="bindState" />
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { apiAbsUrl, newRequest } from '@/util/http'
import WechatOpenLoginPanel from '@/views/login/components/WechatOpenLoginPanel.vue'

const open = defineModel({ type: Boolean, default: false })

const bindRedirectUri = apiAbsUrl('user/login/wechat/open/bind/callback')
const bindState = ref('')

function onOpen() {
  bindState.value = ''
  newRequest({
    url: 'user/get/wechatBindState',
    loading: true,
    success: (data) => {
      bindState.value = data ?? ''
    }
  })
}

function onClosed() {
  bindState.value = ''
}
</script>

<style lang="scss" scoped>
.wechat-bind-loading {
  min-height: 200px;
}
.wechat-bind-hint {
  margin-bottom: 10px;
}
</style>
